import { supportedChainsIds } from '@app/context/AppContextWrapper';

export function isSupportedChain(chainId: number | undefined) {
  return !chainId ? false : supportedChainsIds.includes(chainId);
}
